import { create } from "zustand";

// transient UI state shared across the topbar and the app shell (e.g. the My Sheets page)
export type ScoreView = "score" | "chord";   // "score" = 타브악보, "chord" = 코드악보

interface UiState {
  scoresPage: boolean;
  setScoresPage: (v: boolean) => void;
  scoreView: ScoreView;
  setScoreView: (v: ScoreView) => void;
}

export const useUi = create<UiState>((set) => ({
  scoresPage: false,
  setScoresPage: (scoresPage) => set({ scoresPage }),
  scoreView: "chord",                          // default to the lead-sheet chord grid
  setScoreView: (scoreView) => set({ scoreView }),
}));
